var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 32",
    style: {
      enableBackground: "new 0 0 350 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#BDBDBD;}\n\t.st2{fill:#5C5C5C;}\n\t.st3{fill:#FF9C74;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.37,31.36H15.63C7.15,31.36,0.28,24.48,0.28,16S7.15,0.64,15.63,0.64h318.73 c8.48,0,15.36,6.88,15.36,15.36S342.85,31.36,334.37,31.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.37,31.53H15.63C7.07,31.53,0.1,24.56,0.1,16S7.07,0.47,15.63,0.47h318.73c8.57,0,15.53,6.97,15.53,15.53 S342.93,31.53,334.37,31.53z M15.63,0.82C7.26,0.82,0.45,7.63,0.45,16s6.81,15.18,15.18,15.18h318.73 c8.37,0,15.18-6.81,15.18-15.18s-6.81-15.18-15.18-15.18H15.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 335.84,
    cy: 11.18,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 335.84,
    cy: 16,
    r: 1.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 335.84,
    cy: 20.82,
    r: 1.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.29,9.63c0.39,0,0.71-0.32,0.71-0.71V7.54c0-0.39-0.32-0.71-0.71-0.71c-0.39,0-0.71,0.32-0.71,0.71v1.38 C16.59,9.31,16.9,9.63,17.29,9.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.29,22.37c-0.39,0-0.71,0.32-0.71,0.71v1.38c0,0.39,0.32,0.71,0.71,0.71c0.39,0,0.71-0.32,0.71-0.71v-1.38 C18,22.69,17.68,22.37,17.29,22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.82,9.52c-0.28-0.28-0.72-0.28-1,0c-0.28,0.28-0.28,0.72,0,1l0.98,0.98c0.28,0.28,0.72,0.28,1,0 c0.28-0.28,0.28-0.72,0-1L11.82,9.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,20.5c-0.28-0.28-0.72-0.28-1,0c-0.28,0.28-0.28,0.72,0,1l0.98,0.98c0.28,0.28,0.72,0.28,1,0 c0.28-0.28,0.28-0.72,0-1L22.8,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.93,16c0-0.39-0.32-0.71-0.71-0.71H8.84c-0.39,0-0.71,0.32-0.71,0.71s0.32,0.71,0.71,0.71h1.38 C10.61,16.71,10.93,16.39,10.93,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.75,15.29h-1.38c-0.39,0-0.71,0.32-0.71,0.71s0.32,0.71,0.71,0.71h1.38c0.39,0,0.71-0.32,0.71-0.71 S26.14,15.29,25.75,15.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.79,20.5l-0.98,0.98c-0.28,0.28-0.28,0.72,0,1c0.28,0.28,0.72,0.28,1,0l0.98-0.98c0.28-0.28,0.28-0.72,0-1 C12.52,20.23,12.07,20.23,11.79,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,11.5l0.98-0.98c0.28-0.28,0.28-0.72,0-1c-0.28-0.28-0.72-0.28-1,0L21.8,10.5c-0.28,0.28-0.28,0.72,0,1 C22.07,11.77,22.52,11.77,22.8,11.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 17.29,
    cy: 16,
    r: 4.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.887976b61378229b347cf5da547d098a.svg";
export { ForwardRef as ReactComponent };